import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapse, MediaQuery } from '@as/cotopaxi';
import { Badge, Box, Stack, TextAlpha } from '@yonderland/andes-react';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useElementIsVisible } from '../../hooks/useElementIsVisible';
import { useFeefoWidget } from '../../hooks/useFeefoWidget';
import { makeGetProductDefaults } from '../../redux/product/selectors/ProductSelector';
const DEFAULT_REVIEW_OVERVIEW_ID = 'review-overview';
const ProductReviewContainer = ({ title, productReviewsAverage, productId, }) => {
    const { productCode } = useSelector(makeGetProductDefaults());
    const ref = useRef(null);
    const isVisible = useElementIsVisible(ref, { threshold: 0.01 });
    const { renderFeefoWidget } = useFeefoWidget(productCode, isVisible);
    if (!(productReviewsAverage === null || productReviewsAverage === void 0 ? void 0 : productReviewsAverage.numberOfScores) || !productId) {
        return null;
    }
    const { numberOfScores } = productReviewsAverage;
    return (_jsx(Collapse, { id: "product-review-collapse", title: _jsxs(Stack, { wrap: "wrap", gap: "2", align: "center", children: [_jsx(TextAlpha, { variant: "headingS", children: title }), _jsx(Box, { children: _jsx(Badge, { color: "branded", children: String(numberOfScores) }) })] }), collapseTitle: _jsxs(Stack, { wrap: "wrap", gap: "2", align: "center", children: [_jsx(TextAlpha, { strong: true, children: title }), _jsx(Box, { children: _jsx(Badge, { color: "branded", size: "sm", children: String(numberOfScores) }) })] }), query: [MediaQuery.MOBILE, MediaQuery.TABLET_SMALL], children: _jsx("div", { id: DEFAULT_REVIEW_OVERVIEW_ID, ref: ref, children: _jsx(Box, { paddingBlockStart: {
                    base: '6',
                }, paddingBlockEnd: {
                    base: '6',
                    md: '0',
                }, children: isVisible && renderFeefoWidget() }) }) }));
};
export default ProductReviewContainer;
